import { IconProps } from '@bechtel/gds';
import { HTMLAttributes } from 'react';
export interface StatBlockComponentProps {
  value: string;
  label: string;
  subLabel?: string;
  valueText?: string;
  icon?: IconProps['icon'];
  loading?: boolean;
  iconFillColor?: IconProps['fillColor'];
}
export type StatBlockProps = StatBlockComponentProps & HTMLAttributes<HTMLDivElement>;
